import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy, ViewChild, AfterViewInit } from "@angular/core";
import { UserProfileDetailService } from "./userProfileDetail.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { Subscription } from "rxjs";
import { Subject } from "rxjs/Subject";
import { takeUntil } from "rxjs/operators";
import { SnackBarMessageType, Gender, DeliveryAddressType, ItemTagType, ItemTagStatusType, DateFormatTyps } from "../../shared/contentTypes";
import { Location } from "@angular/common";
import { FurtherAddressViewModel, UserDetailInfoViewModel } from "../../shared/models/userInfo.model";
import Utils from "../../shared/utils";
import { ActivatedRoute, Router } from "@angular/router";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { CoreCOMService } from "../../services/com.service";
import { FormHelperService } from "../../services/formHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { MatTabChangeEvent } from "@angular/material";
import { MaterialTabHelperService } from "../../services/materialTabHelper.service";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { ItemTagViewModel, OrderHistoryViewModel } from "../../shared/models";
import { orderTypes, CustomerInputFieldViewModel } from "../../shared/models/webshop.model";
import { WebShopService } from "../../services/webShop.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { DeleteAccountDialogComponent } from "../../modalDialogs/deleteAccountDialog/deleteAccountDialog.component";
import DateManager from "../../shared/dateManager";
import { DynamicFormFieldsComponent } from "../../directives/dynamicFormFields/dynamicFormFields.component";
import { AccountPaymentService } from "../../services/accountPayment.service";
import { AccountingCustomerDataModel, AccountPaymentLimitResult, AccountPaymentCreditValues, evaluateAccountPaymentLimit } from "../../shared/models/accountPayment.model";
import { AccountPaymentRequestDialogService } from "../../services/accountPaymentRequestDialog.service";

enum UserProfileTab { MyAccount = 0, Orders = 1, Addresses = 2 }
const BASE_TAB_COUNT = UserProfileTab.Addresses + 1;

@Component({
  selector: "user-profile-detail",
  templateUrl: "./userProfileDetail.component.html",
  styleUrls: ["./userProfileDetail.component.scss"],
  providers: [OverlaySpinnerService, UserProfileDetailService, FormHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class UserProfileDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  public userDetailInfoViewModel: UserDetailInfoViewModel = new UserDetailInfoViewModel();
  public userInfoFieldsViewModel: CustomerInputFieldViewModel[] = [];

  public billingInfoInputsViewModel: CustomerInputFieldViewModel[];
  public orderHistory: OrderHistoryViewModel[] = [];
  public currentHeaderIndex: number = 0;
  public isOnline: boolean;
  public showGradient: boolean = true;
  public isButtonActive: boolean = false;
  public userAddressType = DeliveryAddressType;
  public dateInvalid: boolean = false;// to check required field
  public isItemTagEnabled: boolean = false;
  public itemTags: ItemTagViewModel[];
  public itemTagType: ItemTagType = ItemTagType.Text;
  public tagType = ItemTagType;
  public itemTagStatus = ItemTagStatusType;
  public isSmallView: boolean = false;

  private _viewTypeSubscription: Subscription;
  private _langSubscriber: Subscription;
  private _onlineSupscription: Subscription;
  private _offlineSupscription: Subscription;
  private _destroy$ = new Subject<void>();

  @ViewChild("dynamicFormFieldsComponent") dynamicFormFieldsComponent: DynamicFormFieldsComponent;
  public accountPaymentCreditValues: AccountPaymentCreditValues | null = null;
  public accountPaymentCustomer: AccountingCustomerDataModel | null = null;

  public get accountPaymentUsedPercent(): number {
    const me = this;
    const values = me.accountPaymentCreditValues;
    if (values == null || values.limit <= 0) { return 0; }
    return Math.min(100, values.usedBalance / values.limit * 100);
  }
  public accountPaymentLimitResult: AccountPaymentLimitResult = { isBlocked: false, isLimitReached: false, isOverLimit: false, exceedAmount: 0 };
  public isAccountPaymentTabVisible: boolean = false;
  public activationRequestInProgress: boolean = false;


  public selectedYear: string;
  public isOrderListEmpty: boolean;
  public yearList: string[] = [];
  public ordersOfSelectedYear: any[] = [];

  constructor(private _userProfileDetailService: UserProfileDetailService
    , private _location: Location
    , private _coreLanguageService: CoreLanguageService
    , private _coreCOMService: CoreCOMService
    , private _activatedRoute: ActivatedRoute
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _materialTabHelperService: MaterialTabHelperService
    , private _router: Router
    , private _mainnavService: MainnavService
    , private _webshopService: WebShopService
    , private _snackBarService: SnackBarService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _itemTagHelperService: ItemTagHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _accountPaymentService: AccountPaymentService
    , private _accountPaymentRequestDialogService: AccountPaymentRequestDialogService) {
    this.isSmallView = this._mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("UserProfileDetailComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngAfterViewInit(): void {
    const me = this;
    setTimeout(() => {
      me.getRouteData();
    }, 300);
  }

  ngOnInit() {
    const me = this;
    me.isOnline = me._coreCOMService.environment.networkInformation.isOnline;
    me._langSubscriber = this._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._onlineSupscription = me._coreCOMService.environment.events.online.subscribe(() => {
      me.isOnline = true;
      me.PushChanges();
    });

    me._offlineSupscription = me._coreCOMService.environment.events.offline.subscribe(() => {
      me.isOnline = false;
      me.PushChanges();
    });

    me.onViewTypeChanges(me._mainnavService.viewType);
    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.PushChanges();
    });
    me.getUserInfo();
    me.loadOrderHistoryData();

    me.subscribeAccountPaymentStreams();

    me.PushChanges();
  }

  /** Subscribes to the account-payment status, credit, texts and request-progress streams. */
  private subscribeAccountPaymentStreams(): void {
    const me = this;

    me._accountPaymentService.status$.pipe(takeUntil(me._destroy$)).subscribe(() => {
      me.PushChanges();
    });

    me._accountPaymentService.creditValues$.pipe(takeUntil(me._destroy$)).subscribe((info) => {
      me.accountPaymentCreditValues = info;
      me.accountPaymentLimitResult = evaluateAccountPaymentLimit(info, 0);
      me.PushChanges();
    });

    me._accountPaymentService.accountingCustomer$.pipe(takeUntil(me._destroy$)).subscribe((accountPaymentCustomer) => {
      me.accountPaymentCustomer = accountPaymentCustomer;
      me.PushChanges();
    });

    me._accountPaymentService.activationRequestInProgress$.pipe(takeUntil(me._destroy$)).subscribe((inFlight) => {
      me.activationRequestInProgress = inFlight;
      me.PushChanges();
    });
  }

  /** Drop down select year */
  public onYearSelectionChange(event: any) {
    const me = this;
    me.selectedYear = event.target.value;
    me.filterOrdersBySelectedYear();
  }

  /** Orders by selected year */
  public filterOrdersBySelectedYear() {
    const me = this;
    me.ordersOfSelectedYear = me.orderHistory.filter(i => i.order_at.format('YYYY') == me.selectedYear);
    me.PushChanges();
  }
  /** Is order empty: boolean  */
  public checkIfOrderListIsEmpty() {
    const me = this;
    me.isOrderListEmpty = me._userProfileDetailService.isOrderEmpty;
  }

  /**
 * Order type label
 * @param orderType order type number
 * @returns the order type label appended to the value of the order type
 */
  public getOrderTypeLabel(orderType: number) {
    const orderTypeMapping = {
      [orderTypes.pickup]: 'phMenuService_TakeAway',
      [orderTypes.delivery]: 'phMenuService_Delivery',
      [orderTypes.deliveryGroup]: 'phMenuService_Delivery_Group',
      [orderTypes.pickupGroup]: 'phMenuService_TakeAway_Group',
      [orderTypes.webvoucher]: 'phMenuService_Webvoucher',
    };
    return this._coreLanguageService.value(orderTypeMapping[orderType] || 'phMenuService_OderToTable');
  }

  /**
   * Order type icon
   * @param orderType Order type number
   * @returns the order icon appended to the value of the order type
   */
  public getOrderTypeIcon(orderType: number) {
    if (orderType === orderTypes.pickup) {
      return 'shop-icons.svg#ya-hypersoft-abholen';
    } else if (orderType === orderTypes.delivery) {
      return 'shop-icons.svg#ya-hypersoft-liefern';
    } else if (orderType === orderTypes.webvoucher) {
      return 'shop-icons.svg#ya-hypersoft-gutschein';
    } else if (orderType === orderTypes.deliveryGroup || orderType === orderTypes.pickupGroup) {
      return 'hypersoft-user-multi.svg';
    } else {
      return 'shop-icons.svg#ya-hypersoft-tisch';
    }
  }

  /**
   * Format Date
   * @param date number
   * @returns formated date
   */
  public formatDate(date: number) {
    return DateManager.MomentAsString(Utils.GetMomentFromInt(date), DateFormatTyps.DDMMYYYY);
  }

  /** Format currency */
  public formatCurrency(price: number, hasSymbol: boolean = true, useGrouping: boolean = true) {
    return Utils.currencyFormatter(price, this._userProfileDetailService.currencySymbol, hasSymbol, useGrouping);
  }


  /** Returns the initial user address data used to fill the form.*/
  public getUserInfoInitialData() {
    const me = this;
    return me.userDetailInfoViewModel;
  }

  /** email field cann't be edited */
  public disableEmailFormField(): void {
    const me = this;
    if (me.dynamicFormFieldsComponent && me.dynamicFormFieldsComponent.formGroup) {
      const control = me.dynamicFormFieldsComponent.formGroup.get('email');
      control && control.disable();
    }
  }

  /**
   * Triggered whenever the form status changes.
   * Propagates the updated state to any listeners or parent components.
   */
  public onFormStatusChange(): void {
    const me = this;
    me.PushChanges();
  }

  /** Indicates whether the dynamic form group exists.*/
  private get hasDynamicFormGroup(): boolean {
    const me = this;
    return !!(me.dynamicFormFieldsComponent && me.dynamicFormFieldsComponent.formGroup);
  }

  /** Checks whether the dynamic form group is present and currently valid.*/
  public isDynamicFormGroupValid(): boolean {
    const me = this;
    return me.hasDynamicFormGroup && me.dynamicFormFieldsComponent.formGroup.valid;
  }

  /** Marks all controls within the dynamic form group as touched. */
  public markAllFieldsAsTouched(): void {
    const me = this;
    if (me.dynamicFormFieldsComponent) {
      me.dynamicFormFieldsComponent.markAllFieldsAsTouched();
    }
  }

  /**
 * Creates CustomerInputFieldViewModel array for user info fields
 * Used to configure dynamic form fields with validation
 */
  private buildUserInfoFieldsConfig() {
    const me = this;
    me.userInfoFieldsViewModel = me._userProfileDetailService.buildUserInfoFieldsConfig(me.userDetailInfoViewModel);
  }

  /**
   * navigate to Order Detail
   * @param orderId will be used to load data in UserOrderdetail
   */
  public navigateToOrderDetail(orderId: number | string): void {
    const me = this;
    me._router.navigate(["/userOrderDetail", orderId]);
  }

  /** Get order history data*/
  private loadOrderHistoryData() {
    const me = this;
    me._userProfileDetailService.GetOrderHistory((order) => order.order_at_ymd <= order.order_at_ymd)
      .then((orders) => {
        orders.sort((a, b) => b.order_at.valueOf() - a.order_at.valueOf());
        me.orderHistory = [];
        me.orderHistory.push(...orders);
        const orderYearList: string[] = [];
        me.orderHistory.forEach(order => {
          orderYearList.push(order.order_at.format('YYYY'));
          me.selectedYear = orderYearList[0];
        });
        //Filter duplicate years
        me.yearList = [];
        orderYearList.forEach(year => {
          if (me.yearList.indexOf(year) === -1) {
            me.yearList.push(year);
          }
        });
        me.filterOrdersBySelectedYear();
        me.checkIfOrderListIsEmpty();
      }).catch(e => {
        me._coreLogService.error("UserProfileDetailComponent.loadOrderHistoryData", "_userProfileDetailService.GetOrderHistory", e);
      });
    me._userProfileDetailService.OrderHistoryChanges;
  }

  private getRouteData() {
    const me = this;
    me.currentHeaderIndex = +(me._activatedRoute.snapshot.paramMap.get("tabIndex"));
    me._materialTabHelperService.handleTabFocusChange(me.currentHeaderIndex);
    me.PushChanges();
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  public buildFormattedAddressString(...addressData) {
    let addressInfo = "";
    addressData.forEach((info) => {
      if (info) {
        addressInfo += addressInfo.length === 0 ? info : `, ${info}`;
      }
    })
    return addressInfo;
  }

  /**check the offset of scroll on tag list in mobile view
   * when the scroll is at the bottom, gradient will be disapeared
   */
  public handleTagListScrollEvent(event: Event) {
    const me = this;
    const element = (event.target as HTMLElement);
    const isScrolledToBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
    me.showGradient = !isScrolledToBottom;
    me.PushChanges();
  }

  private getUserInfo() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._userProfileDetailService.GetUserDetailInfoViewModel()
      .then(async (userViewModel) => {
        try {
          const webshopSettings = await me._webshopService.getWebshopSettingsDataModel();
          if (webshopSettings && webshopSettings.is_itemtag_enabled) {
            me.isItemTagEnabled = webshopSettings.is_itemtag_enabled;
            const itemTags = await me._itemTagHelperService.GetProductTags();
            if (itemTags && itemTags.length > 0) {
              me.itemTags = itemTags;
              me.itemTagType = webshopSettings.itemtag_type;
              me.PushChanges();
            }
          }
          const accountingEnabledForAnyOrdertype = me._accountPaymentService.isEnabledForAnyOrdertype(webshopSettings);
          me.isAccountPaymentTabVisible = me._webshopService._userHelperService.IsRegistered && accountingEnabledForAnyOrdertype;
          if (me.isAccountPaymentTabVisible) {
            me._accountPaymentService.loadStatus();
            me._accountPaymentService.loadCreditInfo();
          }
          me.PushChanges();
        } catch (e) {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._coreLogService.error("UserProfileDetailComponent.getUserInfo", "try catch", e);
        }
        me.userDetailInfoViewModel = userViewModel;
        me.buildUserInfoFieldsConfig();
        me.PushChanges();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error("UserProfileDetailComponent.getUserInfo", "GetUserDetailInfoViewModel", e);
        me._snackBarService.ShowErrorMessageFailed(90);
      });
  }

  /**routeto address page to edit address
   * @id Id of user address. it is zero for main address and null or undefined for new address
   */
  public navigateToEditAddress(userAddressType: DeliveryAddressType, deliveryaddress: FurtherAddressViewModel) {
    const me = this;
    if (userAddressType === DeliveryAddressType.OldDeliveryAddress) {
      me._router.navigate(["/useraddress", +userAddressType, deliveryaddress.id]);
    } else {
      me._router.navigate(["/useraddress", +userAddressType]);
    }
  }

  public navigateToEditBillingInfoAddress() {
    const me = this;
    me._router.navigate(["/billinginfo"]);
  }

  public navigateBack(): void {
    this._location.back();
  }

  /** Replaces multiple spaces with a single space
   * remove leading & trailing spaces. */
  public normalizeWhitespace(name: string): string {
    if (name && name.trim() !== "") {
      name = name.replace(/\s+/g, ' ').trim();
    }
    return name;
  }

  public saveUserInfo(dateNotValidate: boolean): void {
    const me = this;
    if (dateNotValidate) {
      me.dateInvalid = dateNotValidate;
    } else {
      // Get updated data from dynamic form fields
      if (me.dynamicFormFieldsComponent) {
        const formData = me.dynamicFormFieldsComponent.getDynamicFieldsInput();
        Object.assign(me.userDetailInfoViewModel, formData);
      }

      me._overlaySpinnerService.ShowLayoutSpinner();
      me.userDetailInfoViewModel.fname = me.normalizeWhitespace(me.userDetailInfoViewModel.fname);
      me.userDetailInfoViewModel.name = me.normalizeWhitespace(me.userDetailInfoViewModel.name);
      me._userProfileDetailService.saveUserInfo(me.userDetailInfoViewModel)
        .then(() => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          me.PushChanges();
        })
        .catch(error => {
          me._coreLogService.error("UserProfileDetailComponent.getUserInfo", "GetUserInfoViewModel", error);
          me._overlaySpinnerService.HideLayoutSpinner();
          me._snackBarService.ShowErrorMessageFailed(91);
        })
    }
  }

  public headerTabIndexChange(event: MatTabChangeEvent) {
    const me = this;
    me.currentHeaderIndex = event.index;
    me.PushChanges();
  }

  public handleSwipeRightGesture(event) {
    const me = this;
    event.preventDefault();
    if (me.currentHeaderIndex > 0) {
      --me.currentHeaderIndex;
      if (me.currentHeaderIndex === 1) {// the last tab has fixed footer
      }
      me.PushChanges();
    } else {
      me.handleSwipeBackNavigation();
    }
  }

  public handleSwipeLeftGesture(event) {
    const me = this;
    if (me.isSwipeGestureAllowed(event) && me.currentHeaderIndex < 3) {
      ++me.currentHeaderIndex;
      me.PushChanges();
    }
  }

  /** Computes the zero-based maximum tab index based on which conditional tabs are visible. */
  public get maxTabIndex(): number {
    const me = this;
    let count = BASE_TAB_COUNT; // UserProfileTab.MyAccount(0), Orders(1), Addresses(2) always present
    if (me.isItemTagEnabled) { count++; }
    if (me.isAccountPaymentTabVisible) { count++; }
    return count - 1;
  }

  /** True when the customer's account payment is approved by the operator. */
  public get isAccountPaymentApproved(): boolean {
    const me = this;
    return me._accountPaymentService.isApproved;
  }

  /** True while the activation request is awaiting a decision. */
  public get isAccountPaymentPending(): boolean {
    const me = this;
    return me._accountPaymentService.isPending;
  }

  /** True when the customer's account payment limit is reached. */
  public get isAccountPaymentLimitReached(): boolean {
    const me = this;
    return me.accountPaymentCreditValues != null && me.accountPaymentLimitResult.isLimitReached;
  }

  /** Returns the activation description based on the current account payment status. */
  public get activationDescription(): string {
    const me = this;
    if (!me.accountPaymentCustomer) { return ""; }
    return me.isAccountPaymentPending
      ? me.accountPaymentCustomer.activationPendingStatus
      : me.accountPaymentCustomer.notActivatedDescription;
  }

  /** True when the account payment is pending and the activation pending status text is available. */
  public get showAccountPaymentPendingStatus(): boolean {
    const me = this;
    return me.isAccountPaymentPending && me.accountPaymentCustomer != null && !Utils.IsNullOrEmpty(me.accountPaymentCustomer.activationPendingStatus);
  }

  /** True when the activation info box should be shown. */
  public get showActivationInfoBox(): boolean {
    const me = this;
    return me.showAccountPaymentPendingStatus || !Utils.IsNullOrEmpty(me.activationDescription);
  }

  /** True when the account payment can be requested. */
  public get canRequestActivation(): boolean {
    const me = this;
    return me._accountPaymentService.canRequestActivation;
  }

  /** Opens the account payment activation request confirmation dialog. */
  public openAccountPaymentRequestDialog(): void {
    const me = this;
    if (!me._accountPaymentService.canRequestActivation) { return; }
    me._accountPaymentRequestDialogService.open();
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public handleSwipeBackNavigation() {
    const me = this;
    if (me.isSmallView == true) {
      me._location.back();
    }
  }

  // in browser avoid to swipe when user mark a field(select the text of a field) in user account
  private isSwipeGestureAllowed(event): boolean {
    const me = this;
    const inputFieldClassNames = ["ya-input-container", "ya-input-wrapper", "input-text", "ya-input-text"]
    const elementPointX = event.srcEvent.pageX + event.srcEvent.offsetX;
    const elementPointY = event.srcEvent.pageY + event.srcEvent.offsetY;
    const element = document.elementFromPoint(elementPointX, elementPointY);
    const isMobile = me._coreCOMService.environment.client.isMobile;
    if (!isMobile && element && inputFieldClassNames.some(a => element.classList.contains(a))) {
      return false;
    } else {
      return true;
    }
  }

  public headerTabFocusChange(event: MatTabChangeEvent) {
    const me = this;
    me._materialTabHelperService.TabHeaderTranslateAnimation(event);
  }

  public setItemTagStatus(itemTag: ItemTagViewModel, tagStatus: ItemTagStatusType) {
    const me = this;
    if (!me.isButtonActive) {
      me.isButtonActive = true;
    }
    if (itemTag.itemTagStatus === tagStatus) {
      itemTag.itemTagStatus = ItemTagStatusType.neutral;
    } else {
      itemTag.itemTagStatus = tagStatus;
    }
    me.PushChanges();
  }

  public svgSanitizer(svg: string) {
    const me = this;
    return me._itemTagHelperService.svgSanitizer(svg);
  }

  public saveUserTags() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._itemTagHelperService.saveUserTags(me.itemTags)
      .then(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
        me.isButtonActive = false;
        me.PushChanges();
      })
      .catch(error => {
        me._coreLogService.error("UserProfileDetailComponent.saveUserTags", "_itemTagHelperService.saveUserTags", error);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(92);
      })
  }

  public openDeleteDialog() {
    const me = this;
    me._bottomSheetHelperService.open(DeleteAccountDialogComponent);
  }

  ngOnDestroy(): void {
    const me = this;
    me._destroy$.next();
    me._destroy$.complete();
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._onlineSupscription) {
      me._onlineSupscription.unsubscribe();
    }
    if (me._offlineSupscription) {
      me._offlineSupscription.unsubscribe();
    }
  }

}
